import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core'
import { AuthService} from "../../../services/auth.service";

interface Link {
  label: string;
  path: string;
  requiresLogin?: boolean;
  role?: string | Array<string>;
}

@Component({
  selector: 'app-st-header-with-side-menu',
  templateUrl: './st-header-with-side-menu.component.html',
  styleUrls: ['./st-header-with-side-menu.component.scss'],
  standalone: false
})
export class StHeaderWithSideMenuComponent implements OnInit{
  isMenuCollapsed: boolean = true;
  isAuthenticated: boolean = false;

  @Input()
  links!: Array<Link>;
  filteredLinks: Array<Link> = [];
  constructor(private authService: AuthService) {
  }

  @Input()
  idVal: string = 'headerId';

  ngOnInit(): void {
    this.isAuthenticated = false;
  }
  /*
  ngOnInit(): void {
    this.isAuthenticated = this.authService.isAuthenticated();
    if (this.isAuthenticated) {
      this.filterLinks();
    }
    this.authService.onAuthSuccess().subscribe(() => {
      this.isAuthenticated = true;
      this.filterLinks();
    })
  }*/

  filterLinks() {
    this.filteredLinks = [];
    /*
    this.filteredLinks = this.links.filter((link) => {
      if (!link.requiresLogin) {
        return true;
      }
      if (link.role) {
        return this.authService.hasRole(link.role);
      } else {
        return this.isAuthenticated;
      }
    });*/
  }
}
